// Trek data for The Mountain Mentors
import logo1 from "../assets/images/logo1.jpg"
import HarKiDun from "../assets/images/harkidun.jpg"
import Brahmatal from "../assets/images/brahmatal.jpg"
import BaliPass from "../assets/images/balipass.jpg"
import KuariPass from "../assets/images/kuaripass.jpg"
import Borasu from "../assets/images/borasu.jpg"
import Chopta from "../assets/images/chopta.jpg"
import Gaumukh from "../assets/images/gaumukh.jpg"
import Phulara from "../assets/images/phulara.jpg"
import BlackPeak from "../assets/images/blackpeak.jpg"
import Chardham from "../assets/images/chardham.jpg"
import Lohith from "../assets/images/lohith.jpeg" 

export const treks = [
  {
    id: 1,
    name: "Hampta Pass Trek",
    location: "Himachal Pradesh",
    duration: "5 Days / 4 Nights",
    difficulty: "Moderate",
    altitude: "14,100 ft",
    actualPrice: "₹9,999",
    offerPrice: "₹7,499",
    shortDescription: "Experience the dramatic landscapes as you traverse from lush green valleys to barren deserts.",
    longDescription: "The **Hampta Pass Trek** in **Himachal Pradesh** offers one of the most dramatic landscape transitions in the **Himalayas** — lush green valleys of **Kullu** on one side and the arid, barren mountains of **Lahaul-Spiti** on the other. Spanning about **26 km** and reaching an altitude of **14,100 ft**, this **five-day trek** from **Manali** to **Chhatru** via **Jobra**, **Chika**, **Balu ka Ghera**, **Sia Goru**, and the **Hampta Pass** is filled with ever-changing terrain — from **pine and birch forests** to **wildflower meadows**, **glaciers**, and **rocky slopes**. The trek’s highlight is crossing the **Hampta Pass** itself, a breathtaking vantage point where two contrasting worlds of Himachal unfold. A visit to the stunning **Chandratal Lake** near Chhatru adds to its charm. Rated **easy to moderate**, it’s ideal for **beginners** seeking adventure and beauty. The best time to visit is **June to September**, when snow patches and blooming valleys create a surreal Himalayan experience.",
    image: "https://images.unsplash.com/photo-1688804470994-271ad19db477?w=800&q=80",
    highlights: [
      "Cross the stunning Hampta Pass",
      "Camp beside Chandratal Lake",
      "Witness dramatic landscape changes",
      "Experience Himalayan meadows"
    ],
    itinerary: [
      {
        day: 1,
        title: "Manali Arrival | Drive to Jobra (45 mins drive) | Trek to Chika (2 Kms Trek)",
        description:  `
  - The group will assemble at the pick-up point by 11:00 AM where a briefing session by the trek leader sharing all the necessary details about the trek would be provided. After which, we’ll head towards **Jobra** which is the base camp for the Hampta Pass trek and is located at an altitude of 9,379 ft.
  - The drive from Manali though has many hairpins bends in the road making up for a scenic drive due to the panoramic view of Kullu Valley that you get to glimpse.
  - Traversing through thick forests consisting of pine, maple, and silver birch trees, we will reach **Jobra**. After relaxing for a while, we’ll start our trek toward **Chika**. The sight that you get to witness while trekking is serene and refreshing. From lush green forests consisting of maple, oak, and deodar trees to the stream of **Rani Nallah** flowing through meadows, the landscape that the trekking trail provides is breathtaking, to say the least.
  - We will set up camp in **Chika**. With its vast tapestry of greenery and open skies above, it is perfect for spending peaceful moments.
  - Dinner will be served in the evening followed by an overnight stay in **Chika**.

  **Note**: The pick-up point would be **Manali Mall Road** (tentative). If you arrive in Manali, one day before, it would help your body adapt better to the altitude and weather.
`
      },
      {
        day: 2,
        title: "Chika to Balu Ka Ghera Trek (8.5 Kms, 6 hrs)",
        description:  `
- After early morning breakfast, we will head towards **Balu Ka Ghera**. Balu translates to sand and the trail lives up to the name as the short meadow walk soon gives way to boulders and loose rocks making this part of the trek fall into the moderate category.

- The beauty of this trek is that you get to witness the magic of nature in the form of beautiful landscapes. On one hand, you get the flowing **Jwara** river seemingly following your footsteps, while the mighty **Dhauladhar ranges** beckon you closer. A stream of a waterfall would be waiting amidst the green canopies.

- The terrain starts to flatten as you reach the initial region of **Balu Ka Ghera** which is known as Chota Balu Ka Ghera. As you keep walking, the terrain will start to get rugged again with the rocks being far apart making it tricky to traverse through.

- We will reach **Balu Ka Ghera** soon where we will set camp among the mountains beyond which the Hampta pass awaits us. In the evening, we will have dinner and spend a night under the starry skies.
      `
      },
      {
        day: 3,
        title: "Balu Ka Ghera to Siagoru Trek via Hampta Pass (7 Kms, 9 hrs)",
        description:  `
- After breakfast, we will head towards our next campsite which is **Sia Goru**. The entire trail is made up of boulders and hence the descent is trickier which is why we need to be careful.

- En route, we will be traversing through **Hampta Pass** which is a beautiful trail with a river flowing through it. Blooming flowers of different colors and rainbow are perched at the bank making it a sight to behold. You will also get to see the **Deo Tibba** peak beckoning you closer.

- After enjoying the view at Hampta Pass, we will start our descent. The downhill trail consists of slippery soil and loose stones. A trail with twists and turns will lead you to the valley below and after walking for a while, you will finally reach the base. The opening that reveals itself leads you to **Sia Goru** where we will set camp for the night and spend the rest of the day at leisure.

- Dinner will be served in the evening followed by an overnight stay in **Sia Goru**.
      `
      },
      {
        day: 4,
        title: "Siagoru to Chatru Trek (7 Kms, 5 hrs) | Chatru to Chandratal Drive (48 Kms, 3 Hrs) | Back to Chatru",
        description: `
- After early morning breakfast we will start our downhill trek towards **Chatru**.  
  The vast land lacks vegetation but the tricky slopes give you the adrenaline rush that you might be craving.  
  The descent is tricky so you might have to stay extra vigilant.

- Once we reach Chatru, we’ll drive towards **Chandratal**, which is a beautiful lake located 45 kilometers away from the campsite.  
  However, the drive would only be possible if the weather permits as the harsh weather conditions could be a hindrance.

- After relishing in the beauty of nature and a short sightseeing tour, we’ll head back to **Chatru** where we will set up base camp.

- Dinner will be served in the evening followed by an overnight stay in **Chatru**.
        `
      },
      {
        day: 5,
        title: "Drive from Chatru to Manali (63 Kms, 2.5 Hrs) | Tour Ends",
        description: `
- After early morning tea and breakfast, we will start our return journey and drive from Chatru to **Manali**.  
  The scenic drive consists of mesmerizing views of majestic mountains with the Chandra river flowing by.  
  You also get to traverse through the **Iconic Atal Tunnel**, which itself makes the drive extremely rewarding.

- Upon reaching **Manali**, the group will dissemble and part ways with fond memories.

- End of Trek.
        `
      }
    ],
    inclusions: [
      "Accommodation in camps",
      "All meals during trek",
      "Experienced trek leader and support staff",
      "BonFire",
      "First aid medical kits",
      "All necessary permits",
      "Transport from Manali to Manali"
    ],
    exclusions: [
      "Personal expenses",
      "Insurance",
      "Anything not mentioned in inclusions"
    ]
  },
  {
    id: 2,
    name: "Kedarkantha Trek",
    location: "Uttarakhand",
    duration: "5 Days / 4 Nights",
    difficulty: "Easy to Moderate",
    altitude: "12,500 ft",
    actualPrice: "₹10,999",
    offerPrice: "₹6,499",
    shortDescription: "One of the best winter treks offering panoramic views of Himalayan peaks including Swargarohini.",
    longDescription: "Known as the Queen of Winter Treks, the Kedarkantha Trek is one of India’s most popular Himalayan adventures, rising to 12,500 ft. Steeped in mythology, it is believed that Lord Shiva once meditated here before moving to Kedarnath. This 4-night, 5-day trek begins from Sankri village near Dehradun and takes trekkers through snow-covered forests, frozen lakes like Juda Ka Talab, and scenic campsites overlooking peaks such as Swargarohini, Bandarpoonch, and Black Peak. Suitable for both beginners and experienced trekkers, Kedarkantha offers an unforgettable blend of spirituality, culture, and breathtaking natural beauty. The summit climb rewards trekkers with stunning 360° Himalayan views and mesmerizing sunrises. Winter, from November to February, is the best time to experience its snow-laden charm. With its serene landscapes, warm local hospitality, and legendary folklore, Kedarkantha rightfully holds the title of India’s Best Winter Trek.",
    image: "https://images.unsplash.com/photo-1642498709557-b1bd711dd68b?w=800&q=80",
    highlights: [
      "Summit panoramic views of 12 peaks",
      "Perfect winter trek with snow",
      "Ancient temple at the summit",
      "Pristine pine forests and meadows"
    ],
    itinerary: [
      {
        day: 1,
        title: "Drive From Dehradun To Sankri Base Village (198 Kilometers, 8 Hours Drive )",
        description: "The group will assemble at the pickup point at 06:00 AM. We’ll drive towards Sankri village which is the base camp for the Kedarkantha Trek. Upon reaching Sankri, we’ll check in to our designated homestay. The rest of the day is at leisure and travelers are advised to rest. In the evening, Dinner will be served followed by an overnight stay in Sankri Village."
      },
      {
        day: 2,
        title: "Trek from Sankri to Juda Ka Taal (4 Kilometers, 4 Hours Trek)",
        description: "Trek 4 km through dense pine forests to reach Juda ka Talab, a beautiful frozen lake. Camp beside the lake."
      },
      {
        day: 3,
        title: "Juda Ka Taal To Kedarkantha Base Camp (3 Kilometers, 3 Hours Trek)",
        description: "Ascend through oak forests and meadows to reach Kedarkantha base camp at 11,250 ft. Stunning views of surrounding peaks."
      },
      {
        day: 4,
        title: "Trek To Kedarkantha Peak | Back To Juda ka Taal (9 Kilometers, 8 Hours Trek)",
        description: "Early morning summit push to Kedarkantha peak at 12,500 ft. 360-degree views of Himalayan ranges. Descend to Hargaon camp."
      },
      {
        day: 5,
        title: "Juda ka Taal To Sankri (4 Kilometers, 4 Hours Trek) | Back To Dehradun (8 Hours Drive)",
        description: "Descend through beautiful meadows and forests back to Sankri. Drive back to Dehradun. Trek ends."
      }
    ],
    inclusions: [
      "Accommodation in camps and guesthouse",
      "All meals during trek",
      "Experienced trek leader and guide",
      "BonFire",
      "First aid medical kits",
      "Forest permits",
      "Transport from Dehradun to Dehradun"
    ],
    exclusions: [
      "Personal trekking gear",
      "Personal expenses",
      "Insurance",
      "Any meals during transit"
    ]
  },
  {
    id: 3,
    name: "Rupin Pass Trek",
    location: "Uttarakhand",
    duration: "8 Days / 7 Nights",
    difficulty: "Moderate to Difficult",
    altitude: "15,350 ft",
    actualPrice: "₹25,999",
    offerPrice: "₹19,999",
    shortDescription: "Trek to the mysterious Skeleton Lake surrounded by snow-capped peaks and alpine meadows.",
    longDescription: "Rupin Pass Trek is a stunning high-altitude expedition starting from Dhaula in Uttarakhand and ending at Sangla in Himachal Pradesh, reaching 15,250 ft. Known for its diverse terrain—rocky trails, snowfields, waterfalls, and lush meadows—it offers breathtaking scenery that changes at every turn. With moderate-to-high difficulty, it’s best explored from May–June or September–November.",
    image: "https://images.unsplash.com/photo-1520208422220-d12a3c588e6c?w=800&q=80",
    highlights: [
      "+5% GST (goods and services tax)",
      "Services Sankri to Janki Chatti",
      "Meeting Point( Pickup/ Drop Point ): Prince Chowk, Dehradun",
      "Reporting Time: 6:00 am",
      "Drop Time:6:30 pm to 7:30 pm (Timings are subject to change based on weather and road conditions)",
      "Please reach Dehradun a day before to avoid any delays"
    ],
    itinerary: [
      {
        day: 1,
        title: "Dehradun to Dhaula (235km)",
        description: "For Rupin Pass Trek, you’ll be required to reach Dehradun early in the morning, by 6 am and get yourself onto a vehicle destined towards Mori. A sleepy hamlet, amazingly scenic beautiful village, surrounded by greenish and yellowish paddy fields, Mori is located on the banks of renowned Tons River. Mori is a part of the Tons valley, has a unique culture and history. Retreat for the night in the tents as tomorrow your Rupin Pass Trek commences."
      },
      {
        day: 2,
        title: "Dhaula 1550m to Sewa (1980m). Trek 9km, 5-6hrs",
        description: "This day, enjoy the trek amidst rhododendron woodlands and fields. Post some hours of walking, you will arrive at Sewa. After a great day, spend the night in tents."
      },
      {
        day: 3,
        title: "Sewa (1980m) to Jakha (2680m). Trek12km, 6-7hrs",
        description: "This is an exceptionally scenic day for shutterbugs. As you make your way through some hamlets, get a fine whiff of their local culture and lives. Enjoy the way amidst mixed forests and initial sights of snowy ridges of Dhauladhar range. Arrive at Jakha, the final hamlet of the day that is also the highest in the region. Later in the night, retreat to your tents."
      },
      {
        day: 4,
        title: "Jakha (2680m) to BuransKandi (3259m). Trek 7km, 5-7hrs",
        description: "It is a beautiful walk through the blue pine and maple forest. After a while the trail starts to descend to the river. There is a small bridge taking the trail to the true left of the valley. We camp overnight beside the river beside a spot frequented by shepherds."
      },
      {
        day: 5,
        title: "Burans Kandi (3259m) to DhandrasThach (3560m). Trek 5km, 3-4 hrs",
        description: "You will encounter the first snow bridge upon the river. After snow bridge there will be a heavy ascent for a while. The scenic beauty of Rupin Valley and Rupin river is just mesmerising at this point. From here on, you will encounter lots of snow crossing and at some places snow will be very soft and even it immerses down to your knee level. After few kilometres of snowy adventure, you will reach campsite in Dhandras Thach. This campsite will be having amazing view of Rupin Waterfall and snow-clad peaks."
      },
      {
        day: 6,
        title: "Dhandras thatch (3560M) to Upper Waterfall camp (4054M).",
        description: "This is the shortest trek but toughest than the earlier. There will be multiple climbs today that pass through 2 waterfalls. As if the snow will be melting the slippery will be much higher. You need to hike vertically from Lower Waterfall to the Upper waterfall amidst beautiful scenery. This 3 km hike will be the toughest. Dinner and overnight stay in Camps"
      },
      {
        day: 7,
        title: "Upper Waterfall Camp (4054M) to Rupin Pass (4650M) to Ronti Gad (4090M). Trek 10km",
        description: "There are excellent views of the hanging glaciers and snowfields on the way to the pass. It is a narrow and steep path through the boulders; in case of snow, a rope maybe used. From the pass, one can witness great views of the Kinnaur Kailash range. We descend to the alpine meadows with lots of camping options."
      },
      {
        day: 8,
        title: "Upper Waterfall Camp (4054M) to Rupin Pass (4650M) to Ronti Gad (4090M). Trek 10km",
        description: "Today is a beautiful short trek through blue pine, deodar and oak forest overlooking the Sangla valley. It is a steep descent to Sangla, which is a town connected by road to Shimla. Sangla to Shimla. We will be reaching late night to Shimla. So plan your stay in Shimla well in advance. You can take the next day’s Volvo to Delhi or to the base location."
      }
    ],
    inclusions: [
      "Accommodation in camps and hotels",
      "All meals from Day 1 dinner to Day 8 breakfast. We provide simple nutritious vegetarian food on all days of the trek.",
      "Experienced trek leader",
      "BonFire",
      "First aid, medical kit, oxygen cylinders, Stretchers etc. will be available at all campsites to deal with emergencies.",
      "Forest permits and entry fees",
      "Transport as per itinerary"
    ],
    exclusions: [
      "Personal expenses",
      "GST",
      "Anything not mentioned in Inclusions"
    ]
  },
  {
    id: 4,
    name: "Valley of Flowers Trek",
    location: "Uttarakhand",
    duration: "6 Days / 5 Nights",
    difficulty: "Easy to Moderate",
    altitude: "14,400 ft",
    actualPrice: "₹15,999",
    offerPrice: "₹13,499",
    shortDescription: "Walk through a UNESCO World Heritage Site filled with endemic alpine flowers and rare wildlife.",
    longDescription: "Walk through a UNESCO World Heritage Site filled with endemic alpine flowers and rare wildlife.",
    image: "https://images.unsplash.com/photo-1502439502085-ebf78244370a?q=80&w=1249&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D  ",
    highlights: [
      "UNESCO World Heritage Site",
      "Over 300 species of alpine flowers",
      "Visit Hemkund Sahib",
      "Spot rare Himalayan wildlife"
    ],
    itinerary: [
      {
        day: 1,
        title: "Haridwar to Joshimath",
        description: "Drive from Haridwar to Joshimath (10 hours). En route visit Devprayag, Rudraprayag. Overnight in hotel."
      },
      {
        day: 2,
        title: "Joshimath to Ghangaria",
        description: "Drive to Govindghat, then trek 14 km to Ghangaria village. The trail follows Lakshman Ganga river."
      },
      {
        day: 3,
        title: "Ghangaria to Valley of Flowers and back",
        description: "Early morning trek to Valley of Flowers (5 km). Spend the day exploring the valley filled with alpine flowers. Return to Ghangaria."
      },
      {
        day: 4,
        title: "Ghangaria to Hemkund Sahib and back",
        description: "Trek to Hemkund Sahib (6 km), a revered Sikh pilgrimage site at 14,400 ft. Take a holy dip in the glacial lake. Return to Ghangaria."
      },
      {
        day: 5,
        title: "Ghangaria to Joshimath",
        description: "Descend back to Govindghat and drive to Joshimath. Overnight in hotel."
      },
      {
        day: 6,
        title: "Joshimath to Haridwar",
        description: "Drive back to Haridwar. Trek ends."
      }
    ],
    inclusions: [
      "Accommodation in camps and hotels",
      "All meals from Day 2 breakfast to Day 5 dinner",
      "Experienced trek leader",
      "BonFire",
      "First aid medical kits",
      "Forest permits and entry fees",
      "Transport as per itinerary"
    ],
    exclusions: [
      "Transport to/from Haridwar",
      "Personal expenses",
      "Insurance",
      "Porter services"
    ]
  },
  {
    id: 5,
    name: "Roopkund Trek",
    location: "Uttarakhand",
    duration: "8 Days / 7 Nights",
    difficulty: "Moderate to Difficult",
    altitude: "16,500 ft",
    actualPrice: "₹22,999",
    offerPrice: "₹18,999",
    shortDescription: "Trek to the mysterious Skeleton Lake surrounded by snow-capped peaks and alpine meadows.",
    longDescription: "Trek to the mysterious Skeleton Lake surrounded by snow-capped peaks and alpine meadows.",
    image: "https://images.unsplash.com/photo-1486870591958-9b9d0d1dda99?w=800&q=80",
    highlights: [
      "Mysterious Skeleton Lake",
      "Breathtaking Bedni Bugyal meadows",
      "Views of Trishul and Nanda Ghunti peaks",
      "Rich biodiversity and culture"
    ],
    itinerary: [
      {
        day: 1,
        title: "Kathgodam to Lohajung",
        description: "Drive from Kathgodam to Lohajung base village (10 hours). Scenic journey through Kumaon hills. Overnight in guesthouse."
      },
      {
        day: 2,
        title: "Lohajung to Didna Village",
        description: "Trek 11 km through oak and rhododendron forests to Didna village. Camp overnight."
      },
      {
        day: 3,
        title: "Didna to Ali Bugyal",
        description: "Ascend to the stunning Ali Bugyal meadow at 11,600 ft. Panoramic views of Himalayan peaks. Camp in the meadow."
      },
      {
        day: 4,
        title: "Ali Bugyal to Bedni Bugyal",
        description: "Trek across vast high-altitude meadows to Bedni Bugyal. Visit the sacred Bedni Kund lake. Camp overnight."
      },
      {
        day: 5,
        title: "Bedni Bugyal to Pathar Nachuni",
        description: "Trek to Pathar Nachuni campsite through boulder fields and snow patches. Altitude gain to 13,500 ft."
      },
      {
        day: 6,
        title: "Pathar Nachuni to Roopkund and Bedni Bugyal",
        description: "Early morning trek to Roopkund Lake at 16,500 ft. See the mysterious human skeletons. Return to Bedni Bugyal."
      },
      {
        day: 7,
        title: "Bedni Bugyal to Lohajung",
        description: "Descend back to Lohajung. Overnight in guesthouse."
      },
      {
        day: 8,
        title: "Lohajung to Kathgodam",
        description: "Drive back to Kathgodam. Trek ends."
      }
    ],
    inclusions: [
      "Accommodation in camps and guesthouses",
      "All meals during trek",
      "Experienced trek leader and staff",
      "BonFire",
      "First aid medical kits and oxygen cylinder",
      "All necessary permits",
      "Transport from Kathgodam to Kathgodam"
    ],
    exclusions: [
      "Personal trekking equipment",
      "Personal expenses",
      "Insurance",
      "Porter for personal luggage"
    ]
  },
  {
    "id": 7,
    "name": "Har Ki Dun Trek",
    "location": "Uttarakhand (Garhwal Himalaya)",
    "duration": "7 Days / 6 Nights",
    "difficulty": "Easy to Moderate",
    "altitude": "11,800 ft (approx)",
    "actualPrice": "₹15,500",
    "offerPrice": "₹12,000",
    "shortDescription": "A scenic valley hike through Garhwali villages, forests and meadows to the mythic 'Valley of Gods'.",
    "longDescription": "The Har Ki Dun Trek takes you through the **Govind National Park**, passing through lush Garhwali villages like Taluka and Osla, and climbs gently into the *hanging valley* known as Har Ki Dun at ~11,800 ft. The valley offers views of peaks like **Swargarohini**, serene meadows, glaciers, and a mythological connection — it’s believed this was used by the Pandavas.",
    "image": "https://images.unsplash.com/photo-1744195811733-d363b9a49439?q=80&w=1074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "highlights": [
      "Village culture: Taluka, Osla",
      "Hanging valley (Har Ki Dun)",
      "Peaks: Swargarohini and surrounding ranges",
      "Meadows, forest walks, and glacier views"
    ],
    "itinerary": [
      {
        "day": 1,
        "title": "Drive: Dehradun → Taluka → Sankri",
        "description": "Drive from Dehradun to **Taluka**, then to **Sankri**, which is the base camp. The drive passes through beautiful Garhwal landscapes."
      },
      {
        "day": 2,
        "title": "Trek: Sankri → Taluka → Seema / Osla",
        "description": "From Sankri, trek to **Taluka** and then on to **Osla (Seema)**, walking through forested terrain and rural villages."
      },
      {
        "day": 3,
        "title": "Osla → Har Ki Dun Valley",
        "description": "Ascend from Osla through meadows and streams to reach the **Har Ki Dun Valley**, which is perched and offers stunning panoramic views."
      },
      {
        "day": 4,
        "title": "Exploration / Acclimatization Day",
        "description": "Day to rest or explore: optional hikes to nearby glaciers, viewpoints, or just relax in the valley."
      },
      {
        "day": 5,
        "title": "Har Ki Dun → Osla (Return Trek)",
        "description": "Begin the trek back, retracing your path from Har Ki Dun down to **Osla**, enjoying the descent through meadows and streams."
      },
      {
        "day": 6,
        "title": "Osla → Taluka → Sankri",
        "description": "Trek down from Osla to **Taluka**, then drive (or trek) back to **Sankri**."
      },
      {
        "day": 7,
        "title": "Sankri → Dehradun (Drive)",
        "description": "Drive from Sankri back to **Dehradun**, ending the trek."
      }
    ],
    "inclusions": [
      "Camping / guesthouse accommodation",
      "All meals on trek days",
      "Trek guide & support",
      "BonFire",
      "Tents and camping gear",
      "Permits if needed"
    ],
    "exclusions": [
      "Transport to / from Dehradun (unless specified)",
      "Insurance",
      "Personal expenses",
      "Porter / mule charges if not included"
    ]
  },
  {
    "id": 8,
    "name": "Bali Pass Trek",
    "location": "Uttarakhand (Garhwal Himalaya)",
    "duration": "9 Days / 8 Nights",
    "difficulty": "Difficult",
    "altitude": "16,080 ft (~4,950 m)",
    "actualPrice": "₹23,000",
    "offerPrice": "₹19,499",
    "shortDescription": "High-altitude pass trek connecting Har Ki Dun Valley to Yamunotri via Ruinsara Tal.",
    "longDescription": "The Bali Pass Trek is a challenging but rewarding Himalayan expedition. Starting from **Sankri**, the trail goes through the Har Ki Dun Valley, Ruinsara Tal, and alpine meadows, before ascending to the Bali Pass at around **4,950 m (~16,080 ft)**. It then descends to **Lower Dhamni** and ends at **Janki Chatti**, offering spectacular views of peaks like **Swargarohini**, **Black Peak (Kalanag)**, and **Bandarpunch**.",
    "image": "https://images.unsplash.com/photo-1605731867828-ba1caad2500b?q=80&w=735&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "highlights": [
      "Bali Pass crossing at ~4,950 m",
      "Ruinsara Tal (high-altitude lake)",
      "Views of Swargarohini, Kalanag, Bandarpunch",
      "Alpine meadows and glacier terrain"
    ],
    "itinerary": [
      {
        "day": 1,
        "title": "Drive: Dehradun → Sankri",
        "description": "Begin journey from Dehradun, drive through Mussoorie / Mori to **Sankri**, the trailhead."
      },
      {
        "day": 2,
        "title": "Sankri → Taluka → Seema",
        "description": "Trek from Sankri to **Taluka**, then onward to **Seema (Osla)**, crossing forested sections and small villages."
      },
      {
        "day": 3,
        "title": "Seema → Rainbasera",
        "description": "Ascend to **Rainbasera**, a meadow high up in the mountains."
      },
      {
        "day": 4,
        "title": "Rainbasera → Ruinsara Tal",
        "description": "Trek from Rainbasera to **Ruinsara Tal**, a high-altitude lake nestled in the alpine region."
      },
      {
        "day": 5,
        "title": "Ruinsara Tal → Odari Camp",
        "description": "Climb from Ruinsara Tal to **Odari**, gradually ascending as the terrain becomes rugged and rocky."
      },
      {
        "day": 6,
        "title": "Odari → Bali Base Camp",
        "description": "Ascend from Odari to **Bali Base Camp**, preparing for the pass crossing."
      },
      {
        "day": 7,
        "title": "Pass Day: Base Camp → Bali Pass → Lower Dhamni",
        "description": "Early morning push to **Bali Pass (~4,950 m / 16,080 ft)**, then descend to **Lower Dhamni**."
      },
      {
        "day": 8,
        "title": "Lower Dhamni → Yamunotri → Janki Chatti",
        "description": "Trek down via **Yamunotri** (holy temple), and then to **Janki Chatti**."
      },
      {
        "day": 9,
        "title": "Drive: Janki Chatti → Dehradun",
        "description": "Exit trek by driving from Janki Chatti back to Dehradun."
      }
    ],
    "inclusions": [
      "Tents and camping gear",
      "All meals on trek days",
      "Trek guide, cook, and support staff",
      "BonFire",
      "Permits (if needed)",
      "Sleeping bags / mats"
    ],
    "exclusions": [
      "Transportation to / from Dehradun (unless specified)",
      "Insurance",
      "Personal trekking gear",
      "Porter cost (if not part of package)"
    ]
  },
  {
    "id": 9,
    "name": "Borasu Pass Trek",
    "location": "Uttarakhand → Himachal Pradesh",
    "duration": "9 Days / 8 Nights",
    "difficulty": "Moderate to Difficult",
    "altitude": "17,880 ft (~5,450 m)",
    "actualPrice": "₹45,500",
    "offerPrice": "₹35,000",
    "shortDescription": "A high-altitude cross-over trek from Har Ki Dun valley to Baspa Valley via Borasu Pass.",
    "longDescription": "The Borasu Pass Trek begins at **Sankri** in Uttarakhand, moves through the serene Har Ki Dun valley, then ascends to the Borasu Pass at ~5,450 m. The trail offers striking views of Swargarohini, Black Peak, rugged glaciers, meadows, and remote Himalayan landscapes, before descending into Kinnaur’s Baspa Valley and ending at Chitkul. ",
    "image": "https://images.unsplash.com/photo-1741660420355-aed07ee9208f?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "highlights": [
      "Borasu Pass crossing (~5,450 m)",
      "Views of Swargarohini and Black Peak",
      "Remote Garhwal and Kinnaur landscapes",
      "Glacial moraines and alpine meadows"
    ],
    "itinerary": [
      {
        "day": 1,
        "title": "Drive to Sankri",
        "description": "Pick-up from Dehradun and drive ~210 km to Sankri (base camp), passing through mountainous roads and forested terrain."
      },
      {
        "day": 2,
        "title": "Sankri → Taluka → Cheludgad / Seema",
        "description": "Trek from Sankri to Taluka, then further on foot to **Cheludgad / Seema**; the trail passes through forested terrain and small villages."
      },
      {
        "day": 3,
        "title": "Cheludgad → Har Ki Dun",
        "description": "Ascend from Cheludgad to the **Har Ki Dun** valley (around 3,645 m), passing through meadows and scenic ridges."
      },
      {
        "day": 4,
        "title": "Har Ki Dun → Rata Dho via Maninda Tal",
        "description": "From Har Ki Dun, trek to **Rata Dho**, crossing via or visiting **Maninda Tal** (a high-altitude glacial lake), gaining altitude gradually."
      },
      {
        "day": 5,
        "title": "Rata Dho → Sauni Bheda",
        "description": "Trek from Rata Dho up to **Sauni Bheda** camp. Alpine terrain, moraine, possible snow patches."
      },
      {
        "day": 6,
        "title": "Sauni Bheda → Upper Lamjunga (Base for Pass)",
        "description": "Ascend to the **Upper Lamjunga** campsite in preparation for the pass crossing the next day."
      },
      {
        "day": 7,
        "title": "Pass Day: Upper Lamjunga → Borasu Pass → Bonga",
        "description": "Early start to cross **Borasu Pass (~5,450 m)**. After the pass, descend to **Bonga Camp** at lower altitude."
      },
      {
        "day": 8,
        "title": "Bonga → Chitkul",
        "description": "Descend from Bonga through ridges and valleys to **Chitkul**, a picturesque Himalayan village in Kinnaur."
      },
      {
        "day": 9,
        "title": "Departure from Chitkul",
        "description": "Trek ends in Chitkul. Organize transport for your onward journey."
      }
    ],
    "inclusions": [
      "Tents & camping gear",
      "All meals during trek",
      "BonFire",
      "Guide, cook, support staff",
      "Permits and entry fees"
    ],
    "exclusions": [
      "Transport to Sankri / from Chitkul (unless specified)",
      "Insurance",
      "Personal equipment & expenses",
      "Porter cost (unless included)"
    ]
  },
  {
    "id": 10,
    "name": "Kuari Pass Trek",
    "location": "Uttarakhand (Garhwal Himalaya)",
    "duration": "6 Days / 5 Nights",
    "difficulty": "Easy to Moderate",
    "altitude": "12,516 ft (3,815 m) approx",
    "actualPrice": "₹11,000",  
    "offerPrice": "₹8,500",
    "shortDescription": "A beginner-friendly Himalayan trek through alpine meadows and woods, culminating at the panoramic Kuari Pass.",
    "longDescription": "The **Kuari Pass Trek** (also called ‘Curzon Trail’) is a scenic trek through oak and rhododendron forests, grassy meadows, and remote Garhwal villages. The pass offers sweeping Himalayan views, including peaks like Chaukhamba, Nanda Devi, Nilkanth, and more.",
    "image": "https://images.unsplash.com/photo-1562581153-cc5ac116d6bd?q=80&w=923&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "highlights": [
      "Kuari Pass summit with 360° Himalayan panorama",
      "Meadows and Rhododendron forests",
      "Views of Nanda Devi, Chaukhamba, Nilkanth",
      "Trekking through rustic Garhwal villages"
    ],
    "itinerary": [
      {
        "day": 1,
        "title": "Rishikesh → Joshimath",
        "description": "Drive ~255 km from Rishikesh to **Joshimath** (base village), via Devprayag, Karnaprayag, and Chamoli."
      },
      {
        "day": 2,
        "title": "Joshimath → Dhak → Gulling",
        "description": "Drive from Joshimath to **Dhak**, then trek (~5 km) through forests to **Gulling campsite**, passing oak and rhododendron trees."
      },
      {
        "day": 3,
        "title": "Gulling → Khullara",
        "description": "Trek from Gulling to **Khullara** (~6 km), gaining altitude and entering alpine meadows."
      },
      {
        "day": 4,
        "title": "Khullara → Kuari Pass Summit → Return to Khullara / Tali",
        "description": "Early morning trek to **Kuari Pass (~3,815 m)** to watch sunrise over the Himalayas. After summit, return to Khullara or descend to **Tali** for camp."
      },
      {
        "day": 5,
        "title": "Tali / Khullara → Auli → Joshimath",
        "description": "Descend through **Gorson Bugyal** to **Auli**, then drive back to Joshimath."
      },
      {
        "day": 6,
        "title": "Joshimath → Rishikesh",
        "description": "Drive from Joshimath back to Rishikesh (~255 km), ending the trek."
      }
    ],
    "inclusions": [
      "Camping or basic accommodation",
      "All meals during trek",
      "BonFire",
      "Local guide & support staff",
      "Permits as required"
    ],
    "exclusions": [
      "Transport to/from Rishikesh (except trek-related)",
      "Insurance",
      "Personal gear",
      "Porter charges (if not included)"
    ]
  },
  {
    "id": 11,
    "name": "Brahmatal Trek",
    "location": "Uttarakhand (Chamoli region)",
    "duration": "6 Days / 5 Nights",
    "difficulty": "Moderate",
    "altitude": "12,250 ft (~3,738 m)",
    "actualPrice": "₹16,000",
    "offerPrice": "₹12,450",
    "shortDescription": "A serene trek to the frozen Brahmatal Lake with panoramic views of Himalayan peaks.",
    "longDescription": "The **Brahmatal Trek** is one of the most scenic winter / spring treks in Uttarakhand. Starting from **Lohajung**, the trail takes you through oak forests, rhododendron groves, and alpine meadows up to the **Bekaltal** lake, and then to the **Brahmatal Lake** (~12,200 ft). On a clear day, the summit point offers 360° views of Trishul, Nanda Ghunti, Chaukhamba, and other peaks.",
    "image": "https://images.unsplash.com/photo-1517934274943-d1749ff2d7a8?w=800&q=80",
    "highlights": [
      "Brahmatal Lake (often frozen)",
      "360° views from Brahmatal summit",
      "Forests of oak and rhododendron",
      "Winter-trek experience (snow in many seasons)"
    ],
    "itinerary": [
      {
        "day": 1,
        "title": "Kathgodam / Rishikesh → Lohajung",
        "description": "Drive from Kathgodam (or Rishikesh) to **Lohajung**, passing through Almora-Kausani region."
      },
      {
        "day": 2,
        "title": "Lohajung → Bekaltal",
        "description": "Trek ~6 km through forested trails to **Bekaltal** (a small alpine lake), camping by the lakeside."
      },
      {
        "day": 3,
        "title": "Bekaltal → Brahmatal Lake Camp",
        "description": "Traverse meadows and gentle ridges to reach **Brahmatal Lake** and set camp nearby."
      },
      {
        "day": 4,
        "title": "Summit Day: Brahmatal → Brahmatal Top → Return to Camp",
        "description": "Early morning climb to **Brahmatal Top**, enjoy panoramic mountain views, then return to the Brahmatal campsite."
      },
      {
        "day": 5,
        "title": "Brahmatal → Daldum → Lohajung",
        "description": "Descend via **Daldum** towards **Lohajung**, walking through mixed terrain."
      },
      {
        "day": 6,
        "title": "Lohajung → Kathgodam / Rishikesh",
        "description": "Drive back from Lohajung to Kathgodam / Rishikesh, concluding the trek."
      }
    ],
    "inclusions": [
      "Accommodation (tents / guesthouses)",
      "All meals during trek",
      "BonFire",
      "Guide, cook, support staff",
      "Permits / entry fees"
    ],
    "exclusions": [
      "Transport to/from start point (unless specified)",
      "Insurance",
      "Personal trekking gear",
      "Porters (if not included)"
    ]
  },
  {
    "id": 12,
    "name": "Black Peak (Kalanag) Expedition",
    "location": "Uttarakhand (Garhwal Himalaya)",
    "duration": "16 Days",
    "difficulty": "Difficult / Technical Expedition",
    "altitude": "6,387 m (~20,965 ft)", 
    "actualPrice": "₹91,000", 
    "offerPrice": "₹70,000",
    "shortDescription": "A high-altitude technical expedition to Black Peak (Kalanag), one of the prominent peaks in the Saraswati range.",
    "longDescription": "The Black Peak (Kalanag) expedition is a challenging Himalayan climb starting from Sankri in Uttarakhand. The climb goes via Ruinsara Tal and Kyarkoti base camps, culminating in a summit push on the Black Peak at ~6,387 m. Known for its steep snow and ice slopes, the expedition offers an immersive mountaineering experience with spectacular views of the Saraswati and Bandarpoonch ranges. ",
    "image": "https://images.unsplash.com/photo-1670438664300-d6d70b3fbf64?q=80&w=764&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "highlights": [
      "Summit Black Peak (Kalanag) at ~6,387 m", 
      "Base camps at Ruinsara Tal", 
      "High alpine environment and glaciers", 
      "Comprehensive mountaineering expedition experience"
    ],
    "itinerary": [
      {
        "day": 1,
        "title": "Drive to Sankri",
        "description": "Drive from Dehradun (or other pick-up) to Sankri, base for the expedition."
      },
      {
        "day": 2,
        "title": "Acclimatization / Base Camp Setup",
        "description": "Rest day in Sankri or nearby to acclimatize and do gear checks."
      },
      {
        "day": 3,
        "title": "Trek to Ruinsara Tal",
        "description": "Trek from Sankri toward Ruinsara Tal, establishing base camp at the lake."
      },
      {
        "day": 4,
        "title": "Rest / Acclimatization at Ruinsara",
        "description": "Acclimatize near Ruinsara Tal, perform load carries, and prepare for further ascent."
      },
      {
        "day": 5,
        "title": "Advance to Higher Camp / Kyarkoti",
        "description": "Trek / climb to a higher camp (Kyarkoti), navigating glacier / moraine terrain."
      },
      {
        "day": 6,
        "title": "Camp Preparation / Acclimatization",
        "description": "Set up camp, ferry loads, and rest in preparation for summit push."
      },
      {
        "day": 7,
        "title": "Summit Push Preparation",
        "description": "Preparatory day: fix ropes, check weather, final gear prep before summit day."
      },
      {
        "day": 8,
        "title": "Summit Day: Climb to Black Peak Summit",
        "description": "Early morning ascent to Black Peak summit (~6,387 m) followed by descent to a high camp."
      },
      {
        "day": 9,
        "title": "Descent to Lower Camp",
        "description": "Descend from high camp to intermediate camp / base of glacier."
      },
      {
        "day": 10,
        "title": "Return to Ruinsara / Base Camp",
        "description": "Trek down from glacier camp to Ruinsara Tal base camp."
      },
      {
        "day": 11,
        "title": "Rest at Base Camp",
        "description": "Rest day for recovery and breaking down high camp."
      },
      {
        "day": 12,
        "title": "Trek Back to Sankri",
        "description": "Descend from Ruinsara Tal all the way to Sankri."
      },
      {
        "day": 13,
        "title": "Sankri / Buffer Day",
        "description": "Buffer day in case of weather delays or rest."
      },
      {
        "day": 14,
        "title": "Drive out to Dehradun / Exit Point",
        "description": "Drive back from Sankri to the exit point (e.g., Dehradun)."
      },
      {
        "day": 15,
        "title": "Contingency / Additional Buffer",
        "description": "Extra day for any unplanned delays in the expedition."
      },
      {
        "day": 16,
        "title": "Final Debrief & Departure",
        "description": "Group debrief, share experiences, and depart."
      }
    ],
    "inclusions": [
      "High-altitude expedition guide and climbing team",
      "Base and high camp tents",
      "Climbing equipment (ropes, harnesses, etc.)",
      "All meals during the expedition",
      "BonFire",
      "Porters for load carries",
      "Permits / Climbing permissions"
    ],
    "exclusions": [
      "Air / road transport to Sankri (unless specified)",
      "Personal climbing gear (crampons, boots if not provided)",
      "Insurance for high-altitude mountaineering",
      "Emergency evacuation costs (unless insured)",
      "Personal expenses"
    ]
  },
  {
    "id": 13,
    "name": "Gaumukh-Tapovan Trek",
    "location": "Uttarakhand (Garhwal Himalaya)",
    "duration": "7 Days / 6 Nights",
    "difficulty": "Moderate to Difficult",
    "altitude": "14,200 ft (~4,460 m)",
    "actualPrice": "₹19,500",  
    "offerPrice": "₹15,000",
    "shortDescription": "A spiritual and scenic trek from Gangotri to Gaumukh Glacier and Tapovan meadows.",
    "longDescription": "This trek begins in **Gangotri**, ascending to the snout of the Gangotri Glacier at **Gaumukh**, the symbolic source of the Ganga, and then climbs up to the **Tapovan** meadows with dramatic views of Mt. Shivling, Bhagirathi, Meru, and other Himalayan peaks.",
    "image": "https://images.unsplash.com/photo-1628928275321-11dd68c8fbad?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "highlights": [
      "Explore Gaumukh Glacier – source of the Ganga",
      "Camp in Tapovan high-altitude meadows",
      "Panoramic views of Shivling, Meru, Bhagirathi peaks",
      "Spiritual and serene Himalayan environment"
    ],
    "itinerary": [
      {
        "day": 1,
        "title": "Drive: Dehradun / Rishikesh → Gangotri",
        "description": "Long drive (~10–12 hr) from Rishikesh/Dehradun through Uttarkashi to Gangotri, base for the trek."
      },
      {
        "day": 2,
        "title": "Gangotri → Chirbasa",
        "description": "Trek ~9 km from Gangotri to **Chirbasa**, walking through pine / deodar forest and ridges."
      },
      {
        "day": 3,
        "title": "Chirbasa → Bhojbasa → Gaumukh → Return to Bhojbasa",
        "description": "From Chirbasa, trek to **Bhojbasa**, then continue to **Gaumukh Glacier** for views. Then descend back to Bhojbasa for camp."
      },
      {
        "day": 4,
        "title": "Bhojbasa → Tapovan",
        "description": "Ascend steeply from Bhojbasa to the high meadow of **Tapovan**, crossing glacial moraines and rocky terrain."
      },
      {
        "day": 5,
        "title": "Explore Tapovan – Optional Side Hike",
        "description": "Spend the day exploring **Tapovan**, nearby glaciers, or viewpoints (like Kala Pathar), enjoying views of Shivling / Meru."
      },
      {
        "day": 6,
        "title": "Tapovan → Bhojbasa → Chirbasa",
        "description": "Descend from Tapovan to Bhojbasa, then continue to **Chirbasa**, retracing the trail."
      },
      {
        "day": 7,
        "title": "Chirbasa → Gangotri → Drive Out",
        "description": "Trek back to **Gangotri**, then drive out to Dehradun / your exit point."
      }
    ],
    "inclusions": [
      "Camping accommodation",
      "All meals during trek",
      "BonFire",
      "Guide, cook, support staff",
      "Tents and camping equipment",
      "Permits / entry fees"
    ],
    "exclusions": [
      "Transport to/from Gangotri (unless included)",
      "Insurance",
      "Personal gear (sleeping bag, etc.)",
      "Porter (unless included)"
    ]
  },
  {
    "id": 14,
    "name": "Chopta-Tungnath / Chandrashila Trek",
    "location": "Uttarakhand (Garhwal Himalaya)",
    "duration": "4 Days / 3 Nights",
    "difficulty": "Easy to Moderate",
    "altitude": "Chandrashila Peak ~12,100 ft (3,690 m)",  
    "actualPrice": "₹7,799",
    "offerPrice": "₹5,999",
    "shortDescription": "A spiritual trek through Chopta meadows to Tungnath temple and Chandrashila viewpoint.",
    "longDescription": "This trek takes you to **Chopta**, known for its alpine bugyals and dense forests, then to **Tungnath**, the world’s highest Shiva temple, and finally climbs to **Chandrashila Peak** (3,690 m) for stunning Himalayan panorama including Nanda Devi, Trishul, Chaukhamba, and more.",
    "image": "https://images.unsplash.com/photo-1642690167184-eb64f4ef469f?w=800&q=80",
    "highlights": [
      "Trek to Tungnath, highest Shiva temple",
      "Summit Chandrashila peak at sunrise",
      "Scenic Chopta bugyals and rhododendron forest",
      "360° Himalayan views (Trishul, Nanda Devi, Chaukhamba, etc.)"
    ],
    "itinerary": [
      {
        "day": 1,
        "title": "Drive: Rishikesh / Dehradun → Chopta",
        "description": "Drive from Rishikesh or Dehradun to **Chopta**, the trailhead, via Rudraprayag / Ukhimath."
      },
      {
        "day": 2,
        "title": "Chopta → Tungnath → Chandrashila → Chopta Camp",
        "description": "Trek from Chopta to **Tungnath** (~3.5 km), then ascend to **Chandrashila** (1.5 km more). Enjoy sunrise if possible, then return to Chopta or nearby campsite."
      },
      {
        "day": 3,
        "title": "Chopta → Optional Exploration / Rest",
        "description": "Day for rest or optional hikes around Chopta bugyals, or explore nearby meadows. It’s a good acclimatization / leisure day."
      },
      {
        "day": 4,
        "title": "Chopta → Return to Roadhead / Exit",
        "description": "Trek back / drive down from Chopta to the exit point (Rishikesh / Dehradun)."
      }
    ],
    "inclusions": [
      "Camping or guesthouse accommodation",
      "All meals during trek",
      "BonFire",
      "Guide and support staff",
      "Permits (if required)"
    ],
    "exclusions": [
      "Transport to/from Chopta (unless included)",
      "Insurance",
      "Personal trekking gear",
      "Porter / mule cost (if not included)"
    ]
  },
  {
    "id": 15,
    "name": "Chardham Yatra",
    "location": "Uttarakhand",
    "duration": "10 Days / 9 Nights",
    "difficulty": "Easy to Moderate",
    "altitude": "Up to 11,755 ft",
    "actualPrice": "₹42,999",
    "offerPrice": "₹32,999",
    "shortDescription": "A sacred pilgrimage covering the four holy shrines of Yamunotri, Gangotri, Kedarnath, and Badrinath.",
    "longDescription": "The Chardham Yatra is one of the most revered spiritual journeys in India. It covers the four holy temples—Yamunotri, Gangotri, Kedarnath, and Badrinath—nestled in the majestic Himalayas. This pilgrimage offers a blend of divine experience, natural beauty, and cultural richness.",
    "image": Chardham,
    "highlights": [
      "Visit the sacred shrines of Yamunotri, Gangotri, Kedarnath & Badrinath",
      "Scenic drives through the Garhwal Himalayas",
      "Ganga Aarti at Haridwar/Rishikesh",
      "Trek or helicopter ride to Kedarnath",
      "Beautiful river valleys and mountain landscapes"
    ],
    "itinerary": [
      {
        "day": 1,
        "title": "Arrival in Haridwar",
        "description": "Arrive in Haridwar. Evening Ganga Aarti at Har Ki Pauri. Overnight stay in Haridwar."
      },
      {
        "day": 2,
        "title": "Haridwar to Barkot",
        "description": "Drive to Barkot via Mussoorie. Scenic views of Shivalik ranges. Overnight in Barkot."
      },
      {
        "day": 3,
        "title": "Barkot to Yamunotri and Back",
        "description": "Drive to Janki Chatti and trek 6 km to Yamunotri Temple. Visit the sacred hot springs. Return to Barkot."
      },
      {
        "day": 4,
        "title": "Barkot to Uttarkashi",
        "description": "Drive along the Yamuna and Bhagirathi rivers to Uttarkashi. Visit Vishwanath Temple. Overnight stay."
      },
      {
        "day": 5,
        "title": "Uttarkashi to Gangotri and Back",
        "description": "Drive to Gangotri Temple along the Bhagirathi River. Offer prayers and enjoy mountain views. Return to Uttarkashi."
      },
      {
        "day": 6,
        "title": "Uttarkashi to Guptkashi",
        "description": "Long scenic drive to Guptkashi via Rudraprayag. Visit Ardhnareshwar Temple. Overnight stay."
      },
      {
        "day": 7,
        "title": "Guptkashi to Kedarnath",
        "description": "Drive to Sonprayag; trek 16 km to Kedarnath (or take pony/helicopter). Visit the Kedarnath Temple. Overnight stay near the shrine."
      },
      {
        "day": 8,
        "title": "Kedarnath to Guptkashi",
        "description": "Return trek to Sonprayag and drive back to Guptkashi. Rest and overnight stay."
      },
      {
        "day": 9,
        "title": "Guptkashi to Badrinath",
        "description": "Drive to Badrinath via Joshimath. Visit Badrinath Temple and Mana Village. Overnight stay."
      },
      {
        "day": 10,
        "title": "Badrinath to Haridwar",
        "description": "Drive back to Haridwar via Rudraprayag and Devprayag. Yatra ends."
      }
    ],
    "inclusions": [
      "Accommodation on double/triple sharing basis",
      "Breakfast and dinner during the tour",
      "BonFire",
      "All transfers and sightseeing by private vehicle",
      "All necessary permits and toll taxes",
      "Helpline and support staff",
      "Driver allowances and parking charges"
    ],
    "exclusions": [
      "Pony, Doli, or Helicopter charges for Kedarnath",
      "Entry fees, personal expenses",
      "Lunch during travel",
      "Medical or travel insurance",
      "Anything not mentioned in inclusions"
    ]
  },
  {
    "id": 18,
    "name": "Phulara Ridge Trek",
    "location": "Uttarakhand (Uttarkashi / Govind Wildlife Sanctuary)",
    "duration": "6 Days / 5 Nights",
    "difficulty": "Easy to Moderate",
    "altitude": "12,127 ft (~3,700 m)",
    "actualPrice": "₹13,650",  
    "offerPrice": "₹10,500",
    "shortDescription": "A ridge trek with panoramic Himalayan views, offbeat trails, and serene meadows.",
    "longDescription": "The Phulara Ridge Trek is a less-explored Himalayan ridge walk starting and ending at Sankri. The trail passes through dense pine forests, meadows, and culminates at the **Phulara Ridge (~12,127 ft)** with sweeping views of Himalayan peaks like Kedarkantha, Swargarohini, Black Peak, and more.",
    "image": "https://images.unsplash.com/photo-1651663031236-649b715372cc?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "highlights": [
      "360° ridge walk with Himalayan panorama",
      "Views of peaks like Kedarkantha, Swargarohini, Black Peak",
      "Forest trails and high meadows",
      "Offbeat and less crowded trek"
    ],
    "itinerary": [
      {
        "day": 1,
        "title": "Drive: Dehradun → Sankri",
        "description": "Drive from Dehradun (or pick-up) to **Sankri**, base camp for the trek."
      },
      {
        "day": 2,
        "title": "Sankri → Sikolta",
        "description": "Trek from Sankri to **Sikolta** (~7 km) through pine forest."
      },
      {
        "day": 3,
        "title": "Sikolta → Bhoj Gadi / Ridge Start",
        "description": "Trek up to **Bhoj Gadi**, then begin ascent to Phulara Ridge."
      },
      {
        "day": 4,
        "title": "Bhoj Gadi → Phulara Ridge → Pushtara Camp",
        "description": "Ascend along the ridge to **Phulara Ridge (~12,127 ft)**, enjoy panoramic views, then descend to **Pushtara** meadow for camp."
      },
      {
        "day": 5,
        "title": "Pushtara → Taluka → Sankri",
        "description": "Descend from Pushtara through forest / meadows to **Taluka**, then walk / drive back to **Sankri**."
      },
      {
        "day": 6,
        "title": "Sankri → Exit / Drop Point",
        "description": "Trek / drive out from **Sankri** to your exit point (Dehradun etc.)."
      }
    ],
    "inclusions": [
      "Camping accommodation or guesthouse where applicable",
      "All meals during trek",
      "BonFire",
      "Guide and support staff",
      "Camping equipment / tents",
      "Permits"
    ],
    "exclusions": [
      "Transport to / from Sankri (unless included)",
      "Insurance",
      "Personal gear",
      "Porter charges (if not included)"
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Lohith V",
    trek: "Hampta Pass Trek",
    rating: 5,
    comment: "An absolutely incredible experience! The guides were knowledgeable and caring. The views were breathtaking!",
    avatar: Lohith
  },
  {
    id: 2,
    name: "Kushal Reddy",
    trek: "Valley of Flowers",
    rating: 5,
    comment: "The Valley of Flowers was a dream come true. The team made everything seamless. Highly recommended!",
  },
  {
    id: 3,
    name: "Panthan",
    trek: "Kedarkantha Trek",
    rating: 5,
    comment: "Perfect winter trek! The snow-covered trails and summit views were unforgettable. Great organization!",
  }
];

export const aboutContent = {
  title: "About The Mountain Mentors",
  description: "We are passionate mountain enthusiasts dedicated to sharing the beauty and adventure of the Himalayas. With over 10 years of experience in organizing treks across India, we specialize in creating memorable journeys that combine adventure, safety, and cultural immersion.",
  mission: "Our mission is to make the mountains accessible to everyone while promoting responsible and sustainable tourism. We believe in leaving no trace and supporting local communities.",
  values: [
    {
      title: "Safety First",
      description: "Your safety is our top priority. All our guides are certified and trained in first aid and high-altitude rescue."
    },
    {
      title: "Expert Guidance",
      description: "Our experienced trek leaders have extensive knowledge of the Himalayan terrain and local culture."
    },
    {
      title: "Sustainable Tourism",
      description: "We practice and promote eco-friendly trekking, minimizing environmental impact and supporting local communities."
    },
    {
      title: "Quality Equipment",
      description: "We provide high-quality camping gear and ensure all safety equipment meets international standards."
    }
  ]
};

export const contactDetails = {
  "email": "info.mountainmentors@gmail.com",
  "phone": "7983593184",
  "whatsapp": "7983593184",
  "whatsappMessage": "Hello! I want to know more about treks."
};

export const foodMenu = {
  "breakfast": [
      "Aloo Paratha with Pickle",
      "Vegetable Poha",
      "Upma",
      "Dalia",
      "Chole Puri",
      "Bread Toast with Butter / Jam",
      "Boiled Eggs",
      "Protein / Energy Bar"
    ],
    "lunch": [
      "Vegetable Pulao or Jeera Rice with Dal, Salad, Pickle",
      "Rajma Chawal, Papad, Pickle",
      "Steamed Rice, Mixed Dal, Salad, Pickle",
      "Steamed Rice, Kadhi Pakoda, Salad, Pickle",
    ],
    "snacks": [
      "Pakodas (Aloo / Onion / Bread)",
      "Veg Cutlet",
      "Macaroni",
      "Samosa",
      "Maggie"
    ],
    "dinner": [
      "Roti, Chawal, Matar Paneer, Dal Tadka, Salad, Dessart",
      "Roti, Chawal, Mix Veg, Kali Masoor Dal, Salad, Dessart",
      "Roti, Chawal, Aloo Gobi, Channa Dal, Salad, Dessart",
      "Roti, Jeera Rice, Kasoori Methi Aloo, Dal Fry, Salad, Dessart",
      "Steamed Rice, Mixed Dal, Salad, Pickle",
    ]
  };
